export default "__VITE_ASSET__CUDO37vL__"